import PageHeader from "@/components/site/PageHeader";
import { Mission, History, Programs, CTABand } from "@/components/site/AboutSections";
import { Pillars, Leadership } from "@/components/site/Sections";
import { usePageMeta } from "@/lib/usePageMeta";

export default function AboutPage() {
  usePageMeta(
    "About Us — Mission, History & Leadership",
    "Learn the mission, history, and leadership of RE//FORM PLACE CHI — a Chicago-based 501(‌c)(3) faith and community organization formerly known as Pivot Place CHI.",
  );
  return (
    <div data-testid="about-page">
      <PageHeader
        crumb="About Us"
        eyebrow="About RE//FORM PLACE CHI"
        title="Who We"
        accent="Are"
        intro="A Chicago-based nonprofit faith and community organization committed to spiritual formation, community development, leadership cultivation, and whole-person transformation."
        image="/outreach/story-mural-group.webp"
        imagePosition="center 35%"
      />
      <Mission />
      <History />
      <Programs />
      <Pillars />
      <Leadership />
      <CTABand
        title="Come See For Yourself"
        text="Sunday Worship Experience · 12:30 PM CST. There is a seat here with your name on it."
        primary={{ to: "/new-here", label: "Plan Your Visit" }}
        secondary={{ to: "/contact", label: "Contact Us" }}
      />
    </div>
  );
}
